import { get, destroy } from "./base";

const ShopRatingServ = {
  adminAll: (params) => get("/shop-ratings/admin/all", { params }),
  getByShop: (shopId) => get(`/shop-ratings/${shopId}`),
  remove: (id) => destroy(`/shop-ratings/${id}`),
};

export default ShopRatingServ;
